import React from 'react';
import BrandLogo from '@assets/logo.png';
import whitelabelConfig from '@whitelabel-config';
const AppLogo = () => {
    const styles = {
        logoImg: {
            height: '100%',
        },
    };
    return (<div data-testid="app-logo" style={{height:"100%"}}>
        <img src={BrandLogo} alt={whitelabelConfig.uiSettings.logoName} id='app-logo' tabIndex={0} style={styles.logoImg} role='img' aria-label={whitelabelConfig.uiSettings.logoName ? whitelabelConfig.uiSettings.logoName : "BrandLogo"}  />
    </div>
    );
};
export default AppLogo;
